import http from '@/http'
export default {
  namespaced: true,
  state: {
    hasSendLead: false,
    windowScrollTop: 0
  },
  mutations: {
    setHasSendLead(state, hasSendLead) {
      state.hasSendLead = hasSendLead
    },
    setWindowScrollTop(state, windowScrollTop) {
      state.windowScrollTop = windowScrollTop
    }
  },
  actions: {
    async listPublicProfiles({}, { perPage = 10, page = 1 }) {
      try {
        const response = await http.get('/jobs/profiles', { params: { perPage, page } })
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async listPublicProfilesByOutputs({}, knowledge) {
      try {
        const response = await http.post('/jobs/profiles/outputs', { knowledge })
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    hasSendLead: (state) => state.hasSendLead,
    windowScrollTop: (state) => state.windowScrollTop
  }
}
